<!-- <capture-image></capture-image> -->
<input type="file" [attr.aria-label]="getLabel()" [disabled]="isLocked" />
